<template>
  <v-layout
    row
    justify-start
    class="discard-margin text-toolbar-row"
  >
    <v-flex class="pa-0 font-family-control">
      <v-overflow-btn
        v-model="form.font"
        :items="workflowUi(fonts)"
        dense
        :label="adminText('workflowsAll.font_b97c4d4', 'Font')"
        class="toolbar-height elevation-0 mt-0 pt-0 font-family"
        @change="onSelectChange"
      />
    </v-flex>
    <v-flex class="pa-0 flex-shrink font-size-control">
      <v-overflow-btn
        v-model="form.size"
        :items="workflowUi(sizes)"
        dense
        :label="adminText('workflowsAll.size_b715234', 'Size')"
        class="toolbar-height elevation-0 mt-0 pt-0 font-size"
        @change="onSelectChange"
      />
    </v-flex>
    <v-flex class="pa-0 flex-shrink">
      <v-btn-toggle
        v-model="textToolbar"
        class="toolbar-height elevation-0"
        multiple
        @change="onChange"
      >
        <v-btn class="toolbar-height" flat>
          <v-icon>format_bold</v-icon>
        </v-btn>
        <v-btn class="toolbar-height" flat>
          <v-icon>format_italic</v-icon>
        </v-btn>
        <v-btn class="toolbar-height" flat>
          <v-icon>format_underlined</v-icon>
        </v-btn>
        <v-btn class="toolbar-height" flat>
          <v-icon>arrow_upward</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-flex>
    <v-flex class="pa-0 flex-shrink">
      <v-btn-toggle
        v-model="alignment"
        class="toolbar-height elevation-0"
        mandatory
        @change="onChange"
      >
        <v-btn class="toolbar-height" flat>
          <v-icon>format_align_left</v-icon>
        </v-btn>
        <v-btn class="toolbar-height" flat>
          <v-icon>format_align_center</v-icon>
        </v-btn>
        <v-btn class="toolbar-height" flat>
          <v-icon>format_align_right</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-flex>
    <v-flex class="pa-0 flex-shrink">
      <v-btn-toggle
        v-model="colorToolbar"
        class="toolbar-height elevation-0"
        style="width: 40px;"
        multiple
        @change="onChange"
      >
        <v-btn class="toolbar-height color-btn" flat>
          <v-icon
            :style="{ color: form.color === '#FFFFFF' ? '#a6a6a6' : form.color }"
          >
            format_color_text
          </v-icon>
        </v-btn>
        <div class="color-picker">
          <color-picker v-if="isOpenColorPicker()" v-model="color" />
        </div>
      </v-btn-toggle>
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { Sketch } from 'vue-color'
import { fonts, fontSizes } from './builder.utils'

export default {
  name: 'text-toolbar',
  components: {
    'color-picker': Sketch,
  },
  mixins: [WorkflowDisplay],
  props: {
    styles: Object,
  },
  data() {
    return {
      form: {},
      color: {},
      fonts,
      sizes: fontSizes,
      alignment: -1,
      colorToolbar: [],
      textToolbar: [],
      alignmentItems: ['start', 'center', 'end'],
      toolbarItems: ['bold', 'italic', 'underline', 'uppercase'],
    }
  },
  watch: {
    styles: {
      handler(values) {
        this.alignment = this.alignmentItems.indexOf(values.textAlign)
        this.form = { ...values }
        this.textToolbar = this.objectToList(values)
      },
      deep: true,
      immediate: true,
    },
    color: {
      handler() {
        this.form = {
          ...this.form,
          color: this.color.hex,
        }
        this.onChange()
      },
      deep: true,
    },
  },
  methods: {
    isOpenColorPicker() {
      return this.colorToolbar.includes(0)
    },
    onSelectChange() {
      this.$nextTick(this.onChange)
    },
    onChange() {
      this.$emit('update:styles', {
        ...this.form,
        ...this.listToObject(this.textToolbar),
        textAlign: this.alignmentItems[this.alignment],
      })
    },
    listToObject(list) {
      const object = {}
      this.toolbarItems.forEach((item, index) => {
        const toggled = list.find(i => i === index)
        object[item] = (toggled !== undefined)
      })

      return object
    },
    objectToList(object) {
      const list = []
      this.toolbarItems.forEach((item, index) => {
        if (object[item]) {
          list.push(index)
        }
      })

      return list
    },
  },
}
</script>

<style scoped>
.color-picker {
  position: absolute;
  top: 50px;
  right: 12px;
  z-index: 150;
}
.color-btn {
  opacity: 1;
}
.discard-margin {
  margin: 0 !important;
}
.font-family {
  min-width: 138px;
}
.font-size {
  min-width: 72px;
}
.text-toolbar-row {
  flex-wrap: wrap !important;
  gap: 4px;
  min-width: 0;
}
.font-family-control {
  flex: 0 1 138px;
  max-width: 138px;
}
.font-size-control {
  flex: 0 0 72px;
  max-width: 72px;
}
.text-toolbar-row >>> .v-btn {
  min-width: 36px;
  width: 36px;
  padding: 0;
}
>>> .v-input__control {
  height: 36px;
}
>>> .v-input__append-inner {
  width: 32px;
}
>>> .v-select__selections input {
  position: absolute;
}
>>> .v-input__slot {
  margin-bottom: 0;
  height: 36px;
}
>>> .v-input__slot::before {
  border-width: 0 !important;
}
</style>
